import gql from 'graphql-tag'

export const LEAD_DASHBOARD_QUERY = gql`
query leadDashboard {
  leadCoaches {
    id
    firstName
    lastName
    coachSecondaryPeriod {
      id
      startDate
      endDate
    }
  }
  team {
    id
    name
    lead {
      id
      firstName
      lastName
    }
  }
}
`